import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
import { LIGHTGRAY } from '../../../../../styles/colors.style'
import {
	setUserPermissions,
	history,
	isWithinRebookingWindow,
	isOutsideRebookingWindow,
	has150DaysPassed
} from '@helpers'
import { PaymentStatus } from '../../../../../constants/ticket-sale.constants'
import { BpeDiv } from '../styles/styled-form.style'
import FontAwesome from 'react-fontawesome'
import ReactTooltip from 'react-tooltip'
import copyToClipboard from '../../../../../helpers/clipboard.helper'
import { CancelTicketBtn, RebookingTicketBtn, Button } from '../../../../../components/buttons/buttons.component'
import { breakpoints, pointsCovertionRate } from '../../../../../constants'
import ModalConfirmation from '../../../../../components/modal/modal-confirmation.component'
import { Creators as ClientTicketModalCreators } from '../../../../../ducks/client-ticket-modal/client-ticket-modal'
import { routes } from '../../../../../constants/routes.constants'
import { Creators as TicketSaleCreators } from '../../../../../ducks/ticket-sale/ticket-sale'
import Modal from '../../../../../components/modal/modal.component'
import { toastActions } from '../../../../../actions/toast.actions'

const TicketCard = ({
	user,
	status,
	bpeKey,
	isGoing,
	onReturn,
	canReturn,
	sourceCall,
	trackNumber,
	busSeatNumber,
	passengerName,
	partnerTicketStatus,
	showReeboking,
	closeModal,
	setRebookingData,
	originId,
	destinationId,
	rebookingValue,
	ticketId,
	resetTicketSale,
	tickets,
	toastWarning,
	rebookedFrom,
	rebookedTo,
	points,
	buyerId
}) => {
	useEffect(() => {
		setUserPermissions(user)
	})
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [
		showRebookingConfirmationModal,
		setStatusRebookingConfirmationModal
	] = useState(false)
	const [showRebookingBySACModal, setShowRebookingBySACModal] = useState(false)
	const [ticketIdModal, setTicketIdModal] = useState('')
	const [cancelAllModal, setCancelAllModal] = useState(false)
	const [isGoingModal, setIsGoingModal] = useState('')

	function onReturnConfirm(ticketId, cancelAll, isGoing) {
		setTicketIdModal(ticketId)
		setCancelAllModal(cancelAll)
		setIsGoingModal(isGoing)

		setShowConfirmModal(true)
	}

	function onRebookConfirm(ticketId) {
		setTicketIdModal(ticketId)

		const ticket = tickets.find(ticket => ticket.ticketId === ticketId)

		const { departure, busCompany, points, provider, buyerId } = ticket

		const hasPassedLimitDays = has150DaysPassed(departure)
		const busCompanyChecked = busCompany.toLowerCase() === 'planalto'
		const providerChecked = provider.toLowerCase() === 'rj'
		const hasLessThanFourHours = isWithinRebookingWindow(departure)
		const businessChecked = busCompanyChecked && providerChecked

		if (!hasLessThanFourHours) {
			setStatusRebookingConfirmationModal(true)
		} else if (hasLessThanFourHours && !businessChecked) {
			toastWarning({
				message: 'Não é possível mais remarcar esta passagem.'
			})
		} else {
			setShowRebookingBySACModal(true)
		}
	}

	function onConfirmRebookingSAC() {
		setShowRebookingBySACModal(false)
	}

	function onResultRebookConfirm(confirmed) {
		setStatusRebookingConfirmationModal(false)

		if (confirmed) {
			resetTicketSale()
			closeModal()

			setRebookingData({
				isRebooking: true,
				rebookingOriginId: originId,
				rebookingDestinationId: destinationId,
				rebookingValue: rebookingValue,
				rebookingTicketId: ticketId,
				rebookingPoints: points,
				purchaseForCustomerId: buyerId
			})

			history.push(routes.COMPRA_DE_PASSAGEM)
		}
	}

	function onResult(confirmed) {
		setShowConfirmModal(false)
		if (confirmed) {
			ticketId = ticketIdModal
			isGoing = isGoingModal

			onReturn(ticketId, cancelAllModal, isGoing)
		}
	}

	const msgStatus =
		sourceCall === 'employee-sales-revenue'
			? `Status na rodoviária: ${partnerTicketStatus}`
			: null

	return (
		<StyledContainer>
			<ModalConfirmation
				isOpen={showConfirmModal}
				title={'Confirmar cancelamento'}
				onResult={onResult}>
				<span>
					Se você realizar o cancelamento do(s) bilhete(s) de passagem(ns),
					você NÃO conseguirá embarcar no ônibus para viajar.
				</span>
				<br></br>
				<br></br>
				<span>Você deseja prosseguir com o cancelamento?</span>
			</ModalConfirmation>
			<ModalConfirmation
				isOpen={showRebookingConfirmationModal}
				title={'Confirmar remarcação'}
				onResult={onResultRebookConfirm}>
				<span>
					Ao confirmar que deseja remarcar esta passagem, redirecionaremos
					você para a pesquisa de passagens, e você poderá seguir os passos
					normalmente, como se estivesse realizando uma nova compra.
					<br></br>
					<br></br>
					Na etapa de pagamento, será aplicado um <strong>
						desconto
					</strong>{' '}
					no valor da passagem original.
					<br></br>
					<br></br>É importante salientar que, caso o valor da nova
					passagem seja maior que o desconto, a diferença será cobrada. Se
					for menor, a diferença será devolvida.
				</span>
				<br></br>
				<br></br>
				<span>
					<strong>Você deseja prosseguir com a remarcação?</strong>
				</span>
			</ModalConfirmation>
			<Modal
				onClose={onConfirmRebookingSAC}
				isOpen={showRebookingBySACModal}
				title={'Atenção!'}>
				<StyledRebookingSACContainer>
					<span>
						A remarcação não está disponível para esta passagem no
						momento. Para obter ajuda personalizada e verificar suas
						opções, nossa equipe de atendimento está pronta para
						auxiliá-lo. Entre em contato com o SAC da Planalto o quanto
						antes:{' '}
						<a href="tel:5005 505 55">
							<strong>0800 601 4033</strong>
						</a>{' '}
						ou{' '}
						<a href="mailto:sac@planalto.com.br">
							<strong>sac@planalto.com.br</strong>
						</a>
						.
					</span>
					<Button primary onClick={onConfirmRebookingSAC}>
						Entendi
					</Button>
				</StyledRebookingSACContainer>
			</Modal>
			<b className="passenger">{passengerName}</b>
			<div data-tip={msgStatus} data-for="partner-ticket-status-tooltip">
				{!!bpeKey && (
					<BpeDiv>
						<React.Fragment>
							<span
								onClick={() =>
									copyToClipboard(bpeKey.replace(/\s/g, ''))
								}>
								BPE: {bpeKey}
							</span>
							<FontAwesome
								style={{ cursor: 'pointer' }}
								onClick={() =>
									copyToClipboard(bpeKey.replace(/\s/g, ''))
								}
								name="copy"
								size="lg"
								data-tip="Copiar BPE para área de transferência"
								data-for="copy-tooltip"
							/>
						</React.Fragment>

						<ReactTooltip
							id="copy-tooltip"
							aria-haspopup="true"
							effect="solid"
							place="bottom"></ReactTooltip>
					</BpeDiv>
				)}
				<div className="custom-row">
					<span className="track-number">
						<span>Localizador: </span>
						<span>{trackNumber}</span>
					</span>
					<span className="bus-seat">
						<span>Poltrona: </span>
						<span>{busSeatNumber}</span>
					</span>
				</div>
				<div className={`custom-row ticket-${ticketId}`}>
					{ticketId ? (
						<span className="ticket">
							{/* <span>Bilhete: </span>
							<span>{bpeKey}</span> */}
						</span>
					) : null}
					{showReeboking && (
						<RebookingTicketBtn
							type="button"
							onClick={() => onRebookConfirm(ticketId)}>
							Remarcar
						</RebookingTicketBtn>
					)}
					{canReturn && (
						<CancelTicketBtn
							primary
							type="button"
							onClick={() => onReturnConfirm(ticketId, false, isGoing)}
							data-permission={
								sourceCall === 'employee-sales-revenue'
									? '91C1C5DCF70CA00DF87D459972AD20D3E18D2A41'
									: ''
							}>
							Cancelar
						</CancelTicketBtn>
					)}
				</div>
				{rebookedTo && (
					<span>
						Bilhete remarcado para o pedido de número:{' '}
						<strong>{rebookedTo}</strong>
					</span>
				)}
				{rebookedFrom && (
					<span>
						Bilhete remarcado do pedido de número:{' '}
						<strong>{rebookedFrom}</strong>
					</span>
				)}
			</div>
			<hr />
			<ReactTooltip
				id="partner-ticket-status-tooltip"
				aria-haspopup="true"
				effect="solid"
				place="left"></ReactTooltip>
		</StyledContainer>
	)
}

const StyledRebookingSACContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;

	span {
		margin-bottom: 20px;
		line-height: 24px;
	}

	button {
		width: 200px;
		align-self: flex-end;
	}
`

const StyledContainer = styled.div`
	.custom-row {
		display: flex;
		justify-content: space-between;
		margin: 15px 0px;

		button {
			width: auto;
			padding-top: 8px;
			padding-bottom: 8px;
			margin-left: 10px;
			font-size: 1.8rem;
		}

		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			button {
				padding: 8px 10px;
			}
		}
	}

	.ticket-null {
		justify-content: flex-end;
	}
`

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			closeModal: ClientTicketModalCreators.closeModal,
			setRebookingData: TicketSaleCreators.setRebookingData,
			resetTicketSale: TicketSaleCreators.reset,
			toastWarning: toastActions.warning
		},
		dispatch
	)

const mapStateToProps = store => ({
	tickets: store.clientTicketModal.tickets
})

const TicketCardContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(TicketCard)

export default TicketCardContainer
